import moment, { isMoment } from 'moment/moment';

/**
 * @internal
 */
export class ApiUtils {
  static toUnderscoreCase(s: string): string {
    return s.replace(/\.?([A-Z]+)/g, (x, y) => (s.indexOf(x) ? `_` : '') + `${y.toLowerCase()}`);
  }

  static toCamelCase(str: string): string {
    if (!/[_-]/.test(str)) {
      return str;
    }
    return str.toLowerCase().replace(/[_-][a-z0-9]/g, (group) => group.slice(-1).toUpperCase());
  }

  static convert(
    data: string | number | boolean | Date | any[] | File | object,
    isMidBack = false,
  ): string | boolean | number | Date | File | File[] | object {
    if (['boolean', 'number', 'string'].indexOf(typeof data) > -1) {
      if (isMidBack) {
        return data;
      }
      return data.toString();
    }

    if (data instanceof Date) {
      return moment(data).toISOString();
    }

    if (isMoment(data)) {
      if (isMidBack) {
        return data.milliseconds(0).toISOString().replace('.000Z', 'Z');
      }
      return data.toISOString();
    }

    if (Array.isArray(data)) {
      if (data.every((it) => it instanceof File) || isMidBack) {
        return data;
      }

      return JSON.stringify(data);
    }

    if (data instanceof File) {
      return data;
    }

    if (typeof data === 'object' && data !== null && data.constructor === Object) {
      if (isMidBack) return data;
      return JSON.stringify(data);
    }

    throw new Error('Cannot convert input into data for endpoint');
  }
}

/***
 example : attachment; filename=export-power.xlsx
 */
export const parseHeaderFileName = (contentDisposition: string) => {
  const lookup = 'filename=';
  return contentDisposition
    .slice(contentDisposition.indexOf(lookup) + lookup.length)
    .replace('"', '')
    .replace('"', '');
};
